import React, { useState } from "react";

import { Box, Modal } from "@mui/material";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import {
  saveVehicleType,
  updateVehicleType,
} from "../../services/VehicleTypeService";
import CancelPresentationIconButton from "../../../../../common/components/Buttons/CancelPresentationIconButton";
import CommonDivider from "../../../../../common/components/divider/CommonDivider";
import InputField from "../../../../../common/components/FormFields/InputField";
import CheckBoxField from "../../../../../common/components/FormFields/CheckBoxField";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import CommonBackDrop from "../../../../../common/components/CommonBackDrop/CommonBackDrop";
import { CapitalizeStatement } from "../../../../../common/components/Custom Hooks/CapitalizeStatement";
import {
  errorAlert,
  successAlert,
} from "../../../../../common/components/Toasts/CustomToasts";

const ModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  maxHeight: "90%",
  width: "35%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 20,
  // borderRadius: "10px",
  overflowY: "auto",
  p: 2,
};

const defaultValues = {
  vehicleTypeName: "",
  category: null,
  status: true,
};

function VehicleTypeModal(props) {
  const {
    addNewVehicleTypeModal,
    setAddNewVehicleTypeModal,
    populateTable,
    setIsBackdrop,
    selectedRow,
    setSelectedRow,
  } = props;

  const schema = yup.object().shape({
    vehicleTypeName: yup.string().trim().required("Course Name is required"),
  });
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const [postConfirmationModal, setPostConfirmationModal] = useState(false);
  const [finalObject, setFinalObject] = useState(null);

  const handleSaveClick = (data) => {
    const tempObj = {
      id: selectedRow !== null ? selectedRow?.Id : null,
      vehicleTypeName: CapitalizeStatement(data?.vehicleTypeName),
      isActive: data?.status,
    };
    setFinalObject(tempObj);
    setPostConfirmationModal(true);
  };

  const onSubmit = () => {
    setIsBackdrop(true);
    if (selectedRow === null) {
      saveVehicleType(finalObject)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200 || res.statusCode === 201) {
            setIsBackdrop(false);
            successAlert(res?.message);
            setPostConfirmationModal(false);
            setAddNewVehicleTypeModal(false);
            populateTable();
            reset(defaultValues);
            setSelectedRow(null);
            setFinalObject(null);
          } else {
            populateTable();
            errorAlert(res?.message);
            setIsBackdrop(false);
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          setIsBackdrop(false);
        });
    } else {
      updateVehicleType(finalObject)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200 || res.statusCode === 201) {
            setIsBackdrop(false);
            successAlert(res?.message);
            setPostConfirmationModal(false);
            setAddNewVehicleTypeModal(false);
            populateTable();
            reset(defaultValues);
            setSelectedRow(null);
            setFinalObject(null);
          } else {
            populateTable();
            errorAlert(res?.message);
            setIsBackdrop(false);
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          setIsBackdrop(false);
        });
    }
    setPostConfirmationModal(false);
    setSelectedRow(null);
    setFinalObject(null);
  };
  React.useEffect(() => {
    if (selectedRow !== null) {
      setValue("vehicleTypeName", selectedRow?.["Vehicle Type Name"]);
      setValue("status", selectedRow.Status);
    } else {
      reset(defaultValues);
    }
  }, [selectedRow]);
  console.log("selectedRow", selectedRow);
  return (
    <div>
      <Modal
        open={addNewVehicleTypeModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={ModalStyles} className="w-[60%] lg:w-[45%] rounded-lg">
          <form
            onSubmit={handleSubmit(handleSaveClick)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit(handleSaveClick)();
              }
            }}
          >
            <div className="flex justify-between items-center whitespace-nowrap">
              <h1 className="text-lg font-semibold">
                {selectedRow !== null ? "Update" : "New"} Vehicle Type
              </h1>
              <CancelPresentationIconButton
                type={"button"}
                onClick={() => {
                  setAddNewVehicleTypeModal(false);
                  setSelectedRow(null);
                }}
              />
            </div>
            <div className="mb-3">
              {" "}
              <CommonDivider color="#E0E0E0" />
            </div>
            <div className="flex gap-2 items-center ">
              <InputField
                name="vehicleTypeName"
                label="Vehicle Type Name*"
                type={"text"}
                control={control}
                error={errors.vehicleTypeName}
              />

              <CheckBoxField
                name="status"
                style={{ fontWeight: 500 }}
                control={control}
                label="Active"
              />

              <div className="flex gap-2  justify-end ">
                <CommonButton
                  label="Reset"
                  type="button"
                  className="resetButton bg-white text-customRed border border-customRed rounded px-4"
                  onClick={() => reset(defaultValues)}
                />
                <CommonButton
                  label={selectedRow !== null ? "Update" : "Save"}
                  type="submit"
                  className="saveButton bg-customGreen text-white rounded px-5"
                />
              </div>
            </div>
          </form>

          <CommonBackDrop openBackdrop={props.openBackdrop} />
          {postConfirmationModal && (
            <ConfirmationModal
              confirmationOpen={postConfirmationModal}
              confirmationHandleClose={() => setPostConfirmationModal(false)}
              confirmationSubmitFunc={onSubmit}
              confirmationMsg={`Are you sure you want to ${
                selectedRow === null ? "Add" : "Update"
              } this Record?`}
              confirmationButtonMsg={"Confirm"}
              confirmationLabel={"Confirmation"}
            />
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default VehicleTypeModal;
